export default __webpack_public_path__ + "static/media/ic_choose_provider.699b66d5.svg";